import React from 'react';
import { Tabs, Tab } from 'plaid-threads/Tabs';
import { Button, CodeBlock } from 'plaid-threads';

import './index.scss';

interface TabDataProps {
  jsonData: Object;
  pdfData: string;
  title: string | undefined;
}

const TabData: React.FC<TabDataProps> = (props: TabDataProps) => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState<number>(0);
  const [pdfDisplayURL, setPdfDisplayURL] = React.useState<string>('');

  const downloadPDF = () => {
    const url = getPDFBlob();
    const a = document.createElement('a');
    a.href = url;
    a.download = `${props.title} return data`.replace(' ', '_');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // we set a timeout here to make sure the url is not
    // revoked before the file is downloaded
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 10000);
  };

  const getPDFBlob = (): string => {
    const binaryString = atob(props.pdfData);
    const uint8Array = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  };

  const getPDFDisplayURL = () => {
    if (props.pdfData != null) {
      const url = getPDFBlob();
      setPdfDisplayURL(url);
      // we set a timeout here to make sure the url is not
      // revoked before the pdf display loads
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 10000);
    }
  };

  React.useEffect(() => {
    setSelectedTabIndex(1);
  }, []);

  const title = `${props.title} return data`;

  return (
    <div className="FinancialInsights">
      <Tabs
        onChange={(index) => {
          setSelectedTabIndex(index);
          if (index === 0) {
            getPDFDisplayURL();
          }
        }}
        selectedIndex={selectedTabIndex}
      >
        <Tab title="PDF">
          <object
            // toolbar=0 appended to url means pdf options to download
            // do not show up since we have a seperate button for that
            data={pdfDisplayURL + '#toolbar=0'}
            title={title}
            type="application/pdf"
            width="100%"
            height="750px"
            aria-label={title}
          ></object>
        </Tab>
        <Tab title="JSON">
          {
            <CodeBlock
              code={JSON.stringify(props.jsonData, null, 2)}
              onClick={() => navigator.clipboard.writeText(JSON.stringify(props.jsonData, null, 2))}
              title={title}
            />
          }
        </Tab>
      </Tabs>
      {selectedTabIndex === 0 && (
        <div>
          <Button
            inline
            centered
            size={32}
            onClick={() => {
              downloadPDF();
            }}
            className="Download_PDF_Button"
          >
            Download PDF
          </Button>
        </div>
      )}
    </div>
  );
};

export default TabData;
